import css from 'styled-jsx/css';

const styles = css.global`

.figtree-700 {
  font-family: "Figtree", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
}

.figtree-400 {
  font-family: "Figtree", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

body {
    -webkit-font-smoothing: antialiased;
}

#hero-santander-financiamentos {
    overflow: hidden;
    height: 454px;
}

#hero-santander-financiamentos .bg-hero  {
    position: absolute;
    width: 100%;
}

#hero-santander-financiamentos .bg-hero .img-bg-hero {
    width: 100%;
    object-fit: cover;
    height: 454px;
    object-position: top;
}

#hero-santander-financiamentos .ctn-home-24 {
    position: relative;
}

#hero-santander-financiamentos .img-hero {
    position: absolute;
    top: 0;
    /* left: 16px; */
    left: 50%;
    transform: translate(-50%, 0);
}

#hero-santander-financiamentos .hero-contain {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding-top: 170px;
    position: relative;
    max-width: 260px;
    margin: 0 auto;
}

#hero-santander-financiamentos .hero-title {
    color: #FFF;
    font-size: 30px;
    line-height: 30px; 
    max-width: 288px;
}

#hero-santander-financiamentos .hero-subtitle {
    color: #FFF;
    font-size: 14px;
    line-height: normal;
    letter-spacing: -0.28px;
    max-width: 288px;
}

#hero-button-simular-financiamento {
    width: 100%;
    max-width: 210px;
    margin: auto;
    border-radius: 80px;
    height: 50px;
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 5px;
}

@media (min-width: 600px) {
    #hero-santander-financiamentos .img-hero {
        left: auto;
        right: 0;
        transform: none;
    }

    #hero-santander-financiamentos .hero-contain {
        padding-top: 70px;
        max-width: 300px;
        margin: 0;
    }

    #hero-santander-financiamentos .hero-title {
        font-size: 35px;
        line-height: 35px; 
        max-width: 100%;
    }

    #hero-santander-financiamentos .hero-subtitle {
        font-size: 16px;
        letter-spacing: -0.32px;
        max-width: 100%;
    }
    #hero-button-simular-financiamento {
        margin: 50px 0 0;
    }
}

@media (min-width: 800px) {
    #hero-santander-financiamentos .hero-contain {
        max-width: 330px;
    }

    #hero-santander-financiamentos .hero-title {
        font-size: 40px;
        line-height: 40px; 
    }
}

@media (min-width: 992px) {
    #hero-santander-financiamentos .hero-contain {
        max-width: 510px;
    }

    #hero-santander-financiamentos .hero-title {
        line-height: normal; 
    }
    #hero-santander-financiamentos .hero-subtitle {
        font-size: 25px;
        line-height: normal;
        letter-spacing: -0.5px;
    }
}

@media (min-width: 1280px) {
    #hero-santander-financiamentos,
    #hero-santander-financiamentos .bg-hero .img-bg-hero {
        height: 436px;
    }
}`;

export default styles;